import React from "react";
import { Company } from "~/Company";
import { FilterRow } from "~/Filter";

import { Filter } from "~/Driver";
import * as Layout from "~/Layout";
import * as Log from "~/Log";
import * as Preferences from "~/Preferences";
import { Route as GenericRoute } from "~/Route";
import { useWorkReportingLocationFilters } from "~/Driver/Filter";
import { shouldShowSelectAFilterPrompt } from "~/DisabledTable";

export function Page() {
  const updateFilters = Preferences.Put.use();
  const [ loadingFilters, userPreferences] = Preferences.Get.useLoading()
  const { company } = Company.use();
  useWorkReportingLocationFilters();

  const onFilterByBranch = (
    filteredBranchIds: Company.Branch.Branches.BranchIDs
  ) => {
    const filterPreferences = {
      [`${Preferences.preferenceKey("branchFilter")}`]: filteredBranchIds,
    };
    updateFilters.request(
      {
        ...userPreferences,
        ...filterPreferences,
      },
      "Logs Table",
      "branchFilter"
    );
  };

  const onFilterWorkReportingLocation = (
    filteredWorkReportingLocationIds: Filter.Filter
  ) => {
    const filterPreferences = {
      [`${Preferences.preferenceKey(
        "locationFilter"
      )}`]: filteredWorkReportingLocationIds,
    };
    updateFilters.request(
      {
        ...userPreferences,
        ...filterPreferences,
      },
      "Logs Table",
      "locationFilter"
    );
  };

  const disableMissingLogs = shouldShowSelectAFilterPrompt({companyId: company.id, userPreferences})

  return (
    <Layout.Page.Component all>
      <FilterRow>
        <Company.Branch.Branches.Filter.Component onFilter={onFilterByBranch} />
        <Company.Location.Filter.Component
          onFilter={onFilterWorkReportingLocation}
        />
      </FilterRow>

      { disableMissingLogs ? 
        (<Log.PromptToAddFiltersForLogs isLoading={loadingFilters} baseRoute={Page.Route.definition()} />) 
        : (<Log.Summaries baseRoute={Page.Route.definition()} />)
        }
    </Layout.Page.Component>
  );
}

export namespace Page {
  export namespace Route {
    export const definition = () => "/logs";
    export const href = () => definition();
    export const use = () => GenericRoute.use(href());
  }
}
